<template>
  <div v-if="items.length > 0">
    <v-simple-table class="table-full">
      <thead>
        <tr>
          <th
            class="font-weight-bold"
            :class="{ 'text-center': header.center }"
            :width="header.width"
            v-for="(header, indexHeader) in headers"
            :key="indexHeader"
          >
            {{ header.text }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, indexItem) in items" :key="indexItem">
          <template v-for="(header, indexHeader) in headers">
            <template v-if="header.action">
              <td :key="`${indexItem}_${indexHeader}`">
                <v-tooltip bottom v-if="!header.hideEdit">
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      v-text="'far fa-edit'"
                      :class="{'ml-4': header.hiddenRemove}"
                      @click="$emit('edit', item)"
                    ></v-icon>
                  </template>
                  <span>Éditer</span>
                </v-tooltip>
                <v-tooltip bottom v-if="!header.hiddenRemove">
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      class="ml-4"
                      v-text="'far fa-trash-alt'"
                      @click="(dialog = true), (removeItem = item)"
                    ></v-icon>
                  </template>
                  <span>Supprimer</span>
                </v-tooltip>
              </td>
            </template>
            <template v-else-if="header.timeEnd && header.timeStart">
              <td :key="`${indexItem}_${indexHeader}`" v-if="!header.image">
                {{ getByHeader(item, header.timeStart) | moment("HH:mm a") }} -
                {{ getByHeader(item, header.timeEnd) | moment("HH:mm a") }}
              </td>
            </template>
            <template v-else-if="header.modal">
              <td :key="`${indexItem}_${indexHeader}`">
                <v-icon
                  v-text="'fas fa-book-open'"
                  class="ml-4"
                  @click="setContentModal(item.id)"
                ></v-icon>
              </td>
            </template>
            <template v-else-if="header.checkbox">
              <td :key="`${indexItem}_${indexHeader}`">
                <v-checkbox
                        hide-details="auto"
                  :disabled="header.disable"
                  @change="updateStatus(item, header.field)"
                  v-model="item[header.field]"
                  class="mt-0"
                >
                </v-checkbox>
              </td>
            </template>
            <template v-else>
              <td :key="`${indexItem}_${indexHeader}`" v-if="!header.image">
                <template v-if="header.fieldArray">
                  <span
                    class="d-block border-topic-news"
                    v-for="(itemArray, indexItemArray) in getByHeader(
                      item,
                      header.fieldArray
                    )"
                    :key="indexItemArray"
                  >
                    <template v-if="header.fieldArray !== 'cvs'">
                      <span>{{ getByHeader(itemArray, header.field) }}</span>
                    </template>
                    <template v-else>
                      <span
                        class="mb-0 cursor-pointer"
                        style="color: #2F80ED"
                        @click="downloadAs(getByHeader(itemArray, 'id'), getByHeader(itemArray, header.field))"
                      >
                        <v-icon
                          style="color: #2F80ED"
                          v-text="'far fa-file-word'"
                          class="pr-2"
                        ></v-icon>
                        {{ getByHeader(itemArray, header.field) }}
                      </span>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <span
                            v-on="on"
                            class="cursor-pointer pl-1 error--text"
                            @click="
                              (dialog = true),
                                (removeItem = {
                                  id: item.id,
                                  cvs: itemArray.id,
                                  removeFile: true
                                })
                            "
                          >
                            X
                          </span>
                        </template>
                        <span>Supprimer</span>
                      </v-tooltip>
                    </template>
                  </span>
                </template>
                <template v-else>
                  {{ getByHeader(item, header.field) }}
                </template>
              </td>
              <td :key="`${indexItem}_${indexHeader}`" v-else>
                <v-img :src="getImage(item[header.field])" width="100px" />
              </td>
            </template>
          </template>
        </tr>
      </tbody>
    </v-simple-table>
    <div class="mt-4 mb-4 px-8">
      <div class="d-flex align-center fz-13">
        <v-select
          :items="itemPerPageList"
          @input="$emit('changeItemPerPage', $event)"
          :value="limit"
          hide-details
          dense
          outlined
          style="max-width: 90px"
        ></v-select>
        <span class="ml-4 mr-2 w-300"
          >Affichage {{ items.length }} sur {{ totalItem }} items par page</span
        >
        <v-pagination
          class="justify-start"
          @input="$emit('changePage', $event)"
          :length="totalPage"
          :value="currentPage"
        ></v-pagination>
      </div>
    </div>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="380"
      @keydown.esc="dialog = false"
    >
      <v-card class="pb-5 pt-3">
        <v-img
          src="assets/img/logo-color.png"
          width="54"
          class="mx-auto mt-3"
        />
        <v-card-title class="pt-3 font-weight-medium"
          >Confirmez-vous cette action ?</v-card-title
        >

        <div class="text-center mt-5">
          <v-btn
            class="body-1 px-7"
            depressed
            small
            rounded
            color="primary"
            @click="$emit('remove', removeItem), (dialog = false)"
            >Oui</v-btn
          >
          <v-btn
            class="body-1 mr-0 px-7 black--text"
            depressed
            small
            rounded
            color="#E1E1E1"
            @click="dialog = false"
            >Non</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-if="content" v-model="dialogContent" max-width="70%">
      <v-card>
        <v-card-text v-html="content"></v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "TableDefault",
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    totalPage: {
      type: Number,
      default: 1
    },
    totalItem: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 10
    },
    content: {
      type: String,
      default : ''
    }
  },
  data: () => ({
    contentDialog: "",
    dialogContent: "",
    dialog: false,
    removeItem: {},
    itemPerPageList: [50, 100]
  }),
  methods: {

    setContentModal(id) {
      this.$emit('getContent', id);
      this.dialogContent = true;
    },
    updateStatus(item, field) {
      this.items.map(itemFind => {
        if(itemFind === item) {
          itemFind[field] = !itemFind[field];
          item[field] = !item[field];
        }
        return itemFind;
      })
      this.$emit("editStatus", item);
    },
    getByHeader(item, field) {
      let arrayField = field.split(".");
      let itemResult = JSON.parse(JSON.stringify(item));
      arrayField.forEach(f => {
        itemResult = itemResult[f];
      });

      // Format Date
      const dateFields = ["date"];
      if (dateFields.includes(field)) {
        if (this.$moment(itemResult, "YYYY-MM-DD").isValid()) {
          return this.$moment(itemResult, "YYYY-MM-DD").format("DD/MM/YYYY");
        }
      }
      return itemResult;
    }
  }
};
</script>
<style lang="sass">
.table-fixed-height
  .v-input__slot
    align-items: center !important
    justify-content: center !important
.w-300
  width: 300px
.border-topic-news
  border-bottom: 1px solid #ddd
  &:last-child
    border-bottom: none
.v-input__slot
  margin-bottom: 0
</style>
